<template>
  <div>
      
    <!-- ##### header section##### -->
    <div class="breadcumb-area bg-img" :style="`background-image: url(/img/missions/${data.backgroundPicture});`">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-12 col-md-6">
                    <div class="breadcumb-text">
                        <!-- <h5>La Obra</h5> -->
                        <h5>{{data.title.substr(0,7)}}</h5>
                        <h2 class="text-capitalize">{{data.title.substr(7)}}</h2>
                        <p>
                          Después oí la voz del Señor, que decía: ¿A quién enviaré, y quién irá por nosotros? Entonces respondí yo: Heme aquí, envíame a mí.
                          <br> <small>Isaías 6:8</small>
                        </p>
                        <!-- <p>
                          Iglesia La Senda Antigua extiende su mano a diferentes obras misioneras en diferentes partes del mundo. Algunas de estas obras son:
                        </p> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ##### header section ##### -->


    <!-- ##### Ministries Area Start ##### -->
    
    <section class="ministries-area section-padding-100-0">
        <div class="container">
            <!-- <div class="row">
                <div class="col-12">
                    <div class="section-heading text-center mx-auto">                        
                        <p>Iglesia La Senda Antigua extiende su mano a diferentes obras misioneras en diferentes partes del mundo. Algunas de estas obras son:</p>
                    </div>
                </div>
            </div> -->

            <div class="row">

                <!-- ASIA -->
                <div class="col-12 col-md-8 offset-md-2">
                    <div class="single-ministry mb-100">
                        <img :src="'/img/missions/'+ data.coverPicture" style="width:100%" alt="la senda antigua">
                        <div class="ministry-content">
                            <!-- <h3>{{data.title}}</h3> -->
                            <p class="text-justify">
                                {{data.content}}
                            </p>
                            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
                                <input type="hidden" name="cmd" value="_donations" />
                                <input type="hidden" name="business" value="K3UZWGAWL8B4J" />
                                <input type="hidden" name="item_name" :value="data.donationKey" />
                                <input type="hidden" name="currency_code" value="USD" />
                                <input type="image" src="https://www.paypalobjects.com/es_XC/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donar con el botón PayPal" />
                                <img alt="" border="0" src="https://www.paypal.com/es_US/i/scr/pixel.gif" width="1" height="1" />
                            </form>
                        </div>
                    </div>
                </div>

                

            </div>

            <!-- pictures -->
            <div class="row mb-5" v-if="data.images" >
                <div class="col-12">
                    <h3>Galería de Imágenes</h3>
                </div>
                
                <div class="col-md-3" v-for="thumb in data.images" :key="thumb.id" >
                    <div :style="`background:url(${dir + thumb.name}); border:2px #ac8a74 solid;
                                  height:300px; background-size:cover; box-shadow:4px 4px 8px #ddd;`" 
                        class="m-1" @click="showLightbox(thumb.name)" />
                    
                </div>
            </div>





            <lightbox id="mylightbox" v-if="data.images"
                ref="lightbox"
                :images="data.images"
                :directory="dir"
                :timeoutDuration="5000"
            ></lightbox>
        </div>
    </section>
    
  </div>
</template>

<script>

const  data = require("@/assets/content/missions.json")
export default {
   props:["id"],  
   data(){
       return{
           data:{title:""},
           dir: "/img/missions/",           
       }
   },
   mounted(){
       this.data = data.find(i=> i.id == this.id)
       
   },
   methods:{
       showLightbox: function(imageName) {
            this.$refs.lightbox.show(imageName);
        },
   }
}
</script>

<style>

</style>